// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2MsMn","expandIcon":"AccordionButton_expandIcon__AbwM9","expanded":"AccordionButton_expanded__15_zV"};